import React from 'react';
import '../../styles/examination/main.css';

const Main = () => {
    return (
        <div id='examinationMain'>
            <div className="examination-main">
      <div className="container mt-5 mb-5 admin-container">
        <div className="row">
          <div className="col-md-12 pull-left flip sm-pull-none">
            <div className="admin-table">
              <h2 className="my-heading">Exam Rules</h2>
              {/* <p style={{ fontSize: 'large', fontWeight: 500, lineHeight: '25px' }}>
                Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)
              </p> */}
              <div className="table-scrollable">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>View</th>
                    </tr>
                  </thead>
                  <tbody>
                  <tr>
                      <td>
                        B.A., B.Sc., and B.Com (New NEP) Rules  
                      </td>
                      <td>
                        <a
                          className="btn btn-primary btn-download"
                          href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/10/Adobe%20Scan%2023%20Oct%202026.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        P.G. (New NEP) Rules   
                      </td>
                      <td>
                        <a
                          className="btn btn-primary btn-download"
                          href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/10/Adobe%20Scan%2023%20Oct%202026%20(1).pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Submission of Affidavit and Acceptance of Offline Marks for Unuploaded Internal/Practical Examination Marks 
                      </td>
                      <td>
                        <a
                          className="btn btn-primary btn-download"
                          href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/09/Regarding%20Offline%20Inermarks_0001.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                      </td>
                    </tr>
                  <tr>
                      <td>
                        NEP 2020 UG Ordinance 
                      </td>
                      <td>
                        <a
                          className="btn btn-primary btn-download"
                          href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2026/05/ordinance.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                      </td>
                    </tr>
                  <tr>
                      <td>
                        UG Hons (4 yearly NEP) Revised Ordinance 
                      </td>
                      <td>
                        <a
                          className="btn btn-primary btn-download"
                          href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2026/04/UG%20Hons%20(4%20yearly%20NEP)%20Revised%20Ordinance.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                      </td>
                    </tr>
                  <tr>
                      <td>
                        BBA/ BCA (NEP) Ordinance
                      </td>
                      <td>
                        <a
                          className="btn btn-primary btn-download"
                          href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2026/04/bba%20BCA%20ord%202026_merged_01.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                      </td>
                    </tr>
                  <tr>
                      <td>
                        Notice Regarding Non-Acceptance of Further Evaluation Requests after Challenge Evaluation and Scrutiny
                      </td>
                      <td>
                        <a
                          className="btn btn-primary btn-download"
                          href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/01/CHALL-SCR.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                      </td>
                    </tr>
                  <tr>
                      <td>
                        Clarification Regarding New UG NEP
                      </td>
                      <td>
                        <a
                          className="btn btn-primary btn-download"
                          href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/11/Adobe%20Scan%2013%20Nov%202025.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                      </td>
                    </tr>
                  <tr>
                      <td>
                        Decision Regarding Scrutiny After Challenge Evaluation (Meeting Dated 24.09.2025)
                      </td>
                      <td>
                        <a
                          className="btn btn-primary btn-download"
                          href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/10/challange%20scr%20after%20smpl%20scr.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Key Decisions of the Academic Council Meeting held on 02 Sept 2025 
                      </td>
                      <td>
                        <a
                          className="btn btn-primary btn-download"
                          href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/Notification%20(2).pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Circular Regarding Academic Council Meeting dated 29.05.2024 Item Nos. 12(3) and Item no. 08 Decisions
                      </td>
                      <td>
                        <a
                          className="btn btn-primary btn-download"
                          href="https://cdn.ccsuniversity.ac.in/public/pdf/2024/06/circular%20regarding%20Academic%20Council%20Meeting%20dated%2029.05.2024%20Item%20No.%2003%20decision.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Circular Regarding Academic Council Meeting dated 29.05.2024 Item No. 03 decision
                      </td>
                      <td>
                        <a
                          className="btn btn-primary btn-download"
                          href="https://cdn.ccsuniversity.ac.in/public/pdf/2024/06/circular%20regarding%20Academic%20Council%20Meeting%20dated%2029.05.2024%20Item%20Nos.%2012(3)%20and%20Item%20no.%2008%20decisions.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Circular regarding Academic Council Meeting Dated 29-05-2024, Point No. 12(1)
                      </td>
                      <td>
                        <a
                          className="btn btn-primary btn-download"
                          href="https://cdn.ccsuniversity.ac.in/public/pdf/2024/12/Circular%20regarding%20Academic%20Council%20Meeting%20Dated%2029-05-2024,%20Point%20No.%2012(1).pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Circular : Ordinance of Four Year Graduation (Honours/Honours with Research) with Single Major course
                      </td>
                      <td>
                        <a
                          className="btn btn-primary btn-download"
                          href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/03/Ordinance%20of%20Four%20Year%20Graduation%20(Honours_Honours%20with%20Research)%20with%20Single%20Major%20course.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                      </td>
                    </tr>

                    {/* Guidelines row commented out in HTML remains commented */}
                    {/* 
                    <tr>
                      <td>
                        Circular : Guidelines of Four Year Graduation (Honours/Honours with Research) with Single Major course
                      </td>
                      <td>
                        <a
                          className="btn btn-primary btn-download"
                          href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/03/Guidelines%20of%20Four%20Year%20Graduation%20(Honours_Honours%20with%20Research)%20with%20Single%20Major%20course.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                      </td>
                    </tr>
                    */}

                    <tr>
                      <td>
                        Implementation of Modified Format for NEP-2020 Based UG Courses (BA, B.Sc., B.Com.) for Session 2025-2026 as per UP Government Guidelines
                      </td>
                      <td>
                        <a
                          className="btn btn-primary btn-download"
                          href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/05/nep-rules-2025-26.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                      </td>
                    </tr>

                    <tr>
                      <td>Ordinances &amp; Regulations for B.Sc. (Ag.) Hons. course</td>
                      <td>
                        <a
                          className="btn btn-primary btn-download"
                          href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/11/Ordinances%20&%20Regulations%20for%20B.Sc.%20(Ag.)%20Hons.%20course.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                      </td>
                    </tr>

                    <tr>
                      <td>Ordinances of UG-NEP and PG-NEP Courses</td>
                      <td>
                        <a
                          className="btn btn-primary btn-download"
                          href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/12/Ordinance%20of%20UG-NEP%20and%20PG-NEP%20courses.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                      </td>
                    </tr>

                    <tr>
                      <td>General Rules of Semester System for all Courses</td>
                      <td>
                        <a
                          className="btn btn-primary btn-download"
                          href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/rule-sem-system.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                      </td>
                    </tr>

                    <tr>
                      <td>B.A./ B.Com./ M.A./ M.Com. (Private) Courses</td>
                      <td>
                        <a
                          className="btn btn-primary btn-download"
                          href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/rules-pvt-courses.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                      </td>
                    </tr>

                    <tr>
                      <td>Rules for Back Paper Exam</td>
                      <td>
                        <a
                          className="btn btn-primary btn-download"
                          href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/rules-back-paper.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                      </td>
                    </tr>

                    <tr>
                      <td>Rules of Improvement in Semester System Exam</td>
                      <td>
                        <a
                          className="btn btn-primary btn-download"
                          href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/2022-03-28_2664.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                      </td>
                    </tr>

                    <tr>
                      <td>Circular regarding Examination of Persons with Benchmark Disabilities</td>
                      <td>
                        <a
                          className="btn btn-primary btn-download"
                          href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/2022-03-05_2609.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        Circular regarding use of calculator in B.Com., M.Com., B.B.A. and M.B.A. courses
                      </td>
                      <td>
                        <a
                          className="btn btn-primary btn-download"
                          href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/7986.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
            <div className="admission-registration mb-5">
                <div className="container main-box">
                    <div className="box">
                        <div className="col-lg-4 col-sm-12">
                            <div className="image">
                                <span>Official Websites</span>
                                <img src="../assets/images/admission-back.jpg" alt="" />
                            </div>
                        </div>
                        <div className="col-lg-8 col-sm-12">
                            <div className="links">
                                <span style={{ fontWeight: "bold" }}>
                                    Official Websites of MBBS/MD/MS/Dip./D.M./BDS/ PARAMEDICAL/
                                    AYURVEDIC/UNANI COURSES
                                </span>
                                <div className="link">
                                    <span>
                                        <img src="../assets/images/link.svg" alt="" />
                                    </span>
                                    <div className="content">
                                        <a href="https://www.nmc.org.in/" target="blank" rel="noreferrer">
                                            <p>MBBS/MD/MS/Dip./DM</p>
                                        </a>
                                        {/* <p>Campus Admission Portal 2023</p> */}
                                    </div>
                                </div>
                                <div className="link">
                                    <span>
                                        <img src="../assets/images/link.svg" alt="" />
                                    </span>
                                    <div className="content">
                                        <a
                                            href="http://www.paramedicalcouncilofindia.org/"
                                            target="blank"
                                            rel="noreferrer"
                                        >
                                            <p>PARAMEDICAL COURSES</p>
                                        </a>
                                    </div>
                                </div>
                                <div className="link">
                                    <span>
                                        <img src="../assets/images/link.svg" alt="" />
                                    </span>
                                    <div className="content">
                                        <a href="https://dciindia.gov.in/" target="blank" rel="noreferrer">
                                            <p>BDS/MDS</p>
                                        </a>
                                    </div>
                                </div>
                                <div className="link">
                                    <span>
                                        <img src="../assets/images/link.svg" alt="" />
                                    </span>
                                    <div className="content">
                                        <a href="https://www.ccimindia.org/" target="blank" rel="noreferrer">
                                            <p>Registration Form for Vedic Mathematics Diploma 2023-24</p>
                                        </a>
                                    </div>
                                </div>
                                <div className="link">
                                    <span>
                                        <img src="../assets/images/link.svg" alt="" />
                                    </span>
                                    <div className="content">
                                        <a href="https://www.ccsuforms.in/" target="blank" rel="noreferrer">
                                            <p>UNANI AND AYURVEDIC</p>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Main;